import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ConditionsGeneralesPage() {
  useEffect(() => {
    document.title = 'Conditions générales — HASPICA Studio de Design Bordeaux';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />

      <main className="pt-36 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Juridique</p>
          <h1 className="font-heading text-4xl md:text-5xl text-neutral-900 font-light mb-12">
            Conditions générales
          </h1>

          <div className="space-y-10 text-sm text-neutral-600 leading-relaxed">
            <section>
              <h4 id="entreprise" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#entreprise">1. Informations sur l'entreprise</a>
              </h4>
              <p>
                Les présentes conditions générales régissent l'utilisation du site internet de HASPICA.
              </p>
              <ul className="mt-4 space-y-1 pl-4 border-l border-neutral-200">
                <li><strong className="text-neutral-800">Entreprise</strong> : HASPICA</li>
                <li><strong className="text-neutral-800">Dirigeant</strong> : Patrik Haspica</li>
                <li><strong className="text-neutral-800">Statut</strong> : Entrepreneur individuel</li>
                <li><strong className="text-neutral-800">SIRET</strong> : 102 262 441 00011</li>
                <li><strong className="text-neutral-800">Adresse</strong> : 12 Rue Judaïque, 33000 Bordeaux, France</li>
                <li><strong className="text-neutral-800">NAF</strong> : 74.10Z — Activités spécialisées de design</li>
              </ul>
            </section>

            <section>
              <h4 id="objet" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#objet">2. Objet du site</a>
              </h4>
              <p>
                Le site internet de HASPICA a pour objet de présenter les services de design graphique, d'identité visuelle et de conception créative proposés par l'entreprise aux entreprises et aux particuliers.
              </p>
            </section>

            <section>
              <h4 id="propriete" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#propriete">3. Propriété intellectuelle</a>
              </h4>
              <p>
                L'ensemble des contenus présents sur ce site, incluant mais ne se limitant pas aux textes, images, graphismes, logos et éléments de design, sont protégés par le droit de la propriété intellectuelle et restent la propriété exclusive de HASPICA ou de ses partenaires.
              </p>
              <p className="mt-3">
                Toute reproduction, distribution, modification ou utilisation de ces contenus sans autorisation expresse et écrite est strictement interdite.
              </p>
            </section>

            <section>
              <h4 id="responsabilite" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#responsabilite">4. Limitation de responsabilité</a>
              </h4>
              <p>
                HASPICA s'efforce de maintenir les informations présentes sur ce site à jour et exactes. Cependant, l'entreprise ne peut garantir l'absence d'erreurs ou d'omissions et ne saurait être tenue responsable de dommages résultant de l'utilisation du site.
              </p>
            </section>

            <section>
              <h4 id="droit" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#droit">5. Droit applicable</a>
              </h4>
              <p>
                Les présentes conditions générales sont soumises au droit français. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence des tribunaux français.
              </p>
            </section>

            <section>
              <h4 id="contact-cgv" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#contact-cgv">6. Contact</a>
              </h4>
              <p>
                Pour toute question relative aux présentes conditions générales, vous pouvez nous contacter à l'adresse suivante :{' '}
                <a href="mailto:patr1khaspica@inbox.eu" rel="nofollow" className="text-neutral-900 underline hover:no-underline">
                  patr1khaspica@inbox.eu
                </a>
              </p>
            </section>

            <p className="text-xs text-neutral-400 border-t border-neutral-200 pt-6">
              Dernière mise à jour : mars 2026
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
